export const skip = Symbol('__skip__token__');

//# sourceMappingURL=skip.js.map